/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in fr. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('fr', {
	fields: {
		allowDuplicates: 'Autoriser les doublons',
		allowReversals: 'Autoriser les cartes inversées',
		antardasha: 'Antardasha',
		approximateDate: 'Date approximative',
		arcana: 'Arcane',
		aspectTypes: "Types d'aspect",
		avasthaInfo: 'Include avastha details',
		ayanamsa: 'Ayanamsa',
		ayanamsaValue: "Valeur d'ayanamsa personnalisée",
		biorhythm: 'Biorythme',
		birthData: 'Données de naissance',
		birthDate: 'Date de naissance',
		birthLatitude: 'Latitude de naissance',
		birthLongitude: 'Longitude de naissance',
		birthTime: 'Heure de naissance',
		chakra: 'Chakra',
		color: 'Couleur',
		context: "Où vous l'avez vu",
		coordinateSystem: 'Système de coordonnées',
		count: 'Combien',
		currentYear: 'Année',
		date: 'Date',
		datetime: 'Date et heure',
		day: 'Jour',
		division: 'Carte divisionnaire',
		domainWeights: 'Pondération des domaines',
		domains: 'Domaines',
		element: 'Élément',
		endDate: 'Date de fin',
		endDatetime: 'Date et heure de fin',
		expression: "Nombre d'expression",
		family: 'Famille de yoga',
		focus: 'Thématique',
		fullName: 'Nom complet',
		horaryNumber: 'Numéro horaire',
		houseSystem: 'Système de maisons',
		id: 'ID',
		include: 'Corps additionnels',
		interpretation: 'Signification de la position',
		intervalMinutes: 'Intervalle en minutes',
		iso2: 'Code pays',
		lang: 'Langue',
		latitude: 'Latitude',
		letter: 'Lettre initiale',
		lifePath: 'Chemin de vie',
		limit: 'Résultats par page',
		lines: 'Motif des lignes',
		longitude: 'Longitude',
		mahadasha: 'Mahadasha',
		members: 'Membres du groupe',
		minSignificance: 'Signification minimale',
		minStrength: 'Force minimale',
		modernPlanets: 'Inclure les planètes modernes',
		month: 'Mois',
		name: 'Nom',
		natalChart: 'Thème natal',
		nodeType: 'Type de nœud lunaire',
		number: 'Nombre',
		offset: 'Résultats à ignorer',
		orb: 'Orbe',
		person1: 'Personne 1',
		person2: 'Personne 2',
		personA: 'Personne A',
		personB: 'Personne B',
		planet: 'Planète',
		planets: 'Planètes',
		positions: 'Positions du tirage',
		pratyantardasha: 'Pratyantardasha',
		q: 'Recherche',
		question: 'Votre question',
		relocationLatitude: 'Latitude de relocalisation',
		relocationLongitude: 'Longitude de relocalisation',
		returnDate: 'Date de révolution',
		returnYear: 'Année de révolution',
		scheme: 'Schéma de karakas',
		seed: 'Graine',
		sign: 'Signe du zodiaque',
		significators: 'Inclure les significateurs KP',
		sookshma: 'Sookshma',
		soulUrge: 'Soul Urge number',
		spreadName: 'Nom du tirage',
		startDate: 'Date de début',
		startDatetime: 'Date et heure de début',
		strictOrbs: 'Utiliser des orbes plus stricts',
		suit: 'Enseigne',
		system: 'Avastha system',
		targetDate: 'Date cible',
		targetMonth: 'Mois cible',
		time: 'Heure',
		timezone: 'Fuseau horaire',
		top: 'Meilleurs événements par fenêtre',
		transitDate: 'Date de transit',
		transitTime: 'Heure de transit',
		type: 'Type de motif',
		vedic: 'Védique',
		western: 'Occidentale',
		year: 'Année',
		zodiac: 'Signe du zodiaque',
	},
	enums: {
		'arcana.major': 'Arcanes majeurs',
		'arcana.minor': 'Arcanes mineurs',
		'ayanamsa.custom': 'Personnalisé',
		'ayanamsa.kp-newcomb': 'KP Newcomb',
		'ayanamsa.kp-old': 'KP Old',
		'ayanamsa.lahiri': 'Lahiri',
		'ayanamsa.raman': 'B.V. Raman',
		'chakra.Crown': 'Couronne',
		'chakra.Heart': 'Cœur',
		'chakra.Root': 'Racine',
		'chakra.Sacral': 'Sacré',
		'chakra.Solar Plexus': 'Plexus solaire',
		'chakra.Third Eye': 'Troisième œil',
		'chakra.Throat': 'Gorge',
		'context.address': 'Adresse',
		'context.clock': 'Horloge',
		'context.license-plate': "Plaque d'immatriculation",
		'context.phone': 'Numéro de téléphone',
		'context.price': 'Prix',
		'context.receipt': 'Reçu',
		'coordinateSystem.sidereal': 'Sidéral',
		'coordinateSystem.tropical': 'Tropical',
		'element.Air': 'Air',
		'element.Earth': 'Terre',
		'element.Fire': 'Feu',
		'element.Storm': 'Tempête',
		'element.Water': 'Eau',
		'family.akriti': 'Akriti',
		'family.asraya': 'Asraya',
		'family.classical': 'Classique',
		'family.dala': 'Dala',
		'family.sankhya': 'Sankhya',
		'focus.finance': 'Finance',
		'focus.general': 'Général',
		'houseSystem.equal': 'Maisons égales',
		'houseSystem.koch': 'Koch',
		'houseSystem.placidus': 'Placidus',
		'houseSystem.whole-sign': 'Signes entiers',
		'lang.de': 'Allemand',
		'lang.en': 'Anglais',
		'lang.es': 'Espagnol',
		'lang.fr': 'Français',
		'lang.hi': 'Hindi',
		'lang.pt': 'Portugais',
		'lang.ru': 'Russe',
		'lang.tr': 'Turc',
		'nodeType.mean': 'Nœud moyen',
		'nodeType.true': 'Nœud vrai',
		'planet.Jupiter': 'Jupiter',
		'planet.Mars': 'Mars',
		'planet.Mercury': 'Mercure',
		'planet.Saturn': 'Saturne',
		'planet.Venus': 'Vénus',
		'scheme.eight': 'Huit karakas',
		'scheme.seven': 'Sept karakas',
		'suit.cups': 'Coupes',
		'suit.pentacles': 'Deniers',
		'suit.swords': 'Épées',
		'suit.wands': 'Bâtons',
		'system.baladi': 'Baladi',
		'system.deeptadi': 'Deeptadi',
		'system.jagradadi': 'Jagradadi',
		'type.compound': 'Composé',
		'type.master': 'Maître',
		'type.mirror': 'Miroir',
		'type.repeating': 'Répétitif',
		'type.root': 'Racine',
		'type.sequential': 'Séquentiel',
		'zodiac.aquarius': 'Verseau',
		'zodiac.aries': 'Bélier',
		'zodiac.cancer': 'Cancer',
		'zodiac.capricorn': 'Capricorne',
		'zodiac.gemini': 'Gémeaux',
		'zodiac.leo': 'Lion',
		'zodiac.libra': 'Balance',
		'zodiac.pisces': 'Poissons',
		'zodiac.sagittarius': 'Sagittaire',
		'zodiac.scorpio': 'Scorpion',
		'zodiac.taurus': 'Taureau',
		'zodiac.virgo': 'Vierge',
	},
});
